export const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
export const strongPasswordMessage = 'Minimum 8 characters with uppercase, lowercase, and a number';

export const isStrongPassword = (value: string): boolean => strongPasswordRegex.test(value);
